import React from "react";
import { Typography } from "@mui/material";
import { ItemType } from "../../types/types";

interface PublicItemProps {
  item: ItemType;
}

const Description: React.FC<PublicItemProps> = ({ item }) => {
  return <Typography variant="h6">{item.description}</Typography>;
};

export default Description;
